import SpriteSymbol from "../../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.store/svg-sprite-loader@5.2.1/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-CheckIn",
  "use": "icon-CheckIn-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-CheckIn\"><path d=\"M181.819 68.221L64.978 319.734v616.911H961V317.002L844.517 67.997l-662.698 0.224z m319.074 722.283L345.03 616.766h116.886V442.938h116.931v173.873h116.841L539.87 790.415h-38.932l-0.045 0.089zM254.89 130.674h506.252l77.999 173.739h-662.16l77.864-173.739h0.045z\" fill=\"#11C102\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol